<h1 mat-dialog-title>{{ data.modalTitle }}</h1>
<ng-container class="digital-document-wrapper" *ngIf="!docType && !docUploaded">
  <div class="row p-5">
    <div class="col-12">
      <div class="row">
        <div class="col-12 text-center mb-4">
          {{ 'properties.addDocumentsPage.docTypes.chooseMessage' | translate }}
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button class="mr-2 mb-2" mat-stroked-button (click)="onChooseDocType('digital')" color="primary">
            {{ 'properties.addDocumentsPage.docTypes.digital' | translate }}
            <mat-icon fontSet="fal" fontIcon="fa-desktop"></mat-icon>
          </button>
          <button mat-stroked-button (click)="onChooseDocType('paper')" color="accent">
            {{ 'properties.addDocumentsPage.docTypes.paper' | translate }}
            <mat-icon fontSet="fal" fontIcon="fa-scroll"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="text-left w-100">
        <a mat-button (click)="onClose()" mat-raised-button mat-default
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="docType && !docUploaded">
  <mat-dialog-content>
    <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-6">
        <!-- Side menu -->
        <div class="row side-menu">
          <div class="col-7" [ngClass]="{'col-12': !displayedStructures.length}">
            <mat-form-field *ngIf="!contratti && topics && topics.documents">
              <mat-label>{{ 'properties.addDocumentsPage.searchDocument.label' | translate }}</mat-label>
              <input matInput (keyup)="applyFilter($event)"
                placeholder="{{ 'properties.addDocumentsPage.searchDocument.placeholder' | translate }}"
                [disabled]="!topics.documents.length" [value]="searchValue">
            </mat-form-field>
            <h5 *ngIf="!contratti">{{ 'properties.addDocumentsPage.docsSelected' | translate }}</h5>
            <div *ngIf="contratti">
              <mat-form-field *ngIf="topics?.documents">
                <mat-label>Cerca il documento</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Cerca..."
                  [disabled]="!topics?.documents.length" [value]="searchValue">
              </mat-form-field>
              <div class="text-wrapper my-2">
                <strong>{{ 'properties.addDocumentsPage.area.contrattiFornitureServizi' | translate }}</strong>
              </div>
            </div>
            <ng-container *ngFor="let item of topics?.documents; let i = index;">
              <div *ngIf="!item.deleted">
                <div class="text-wrapper" *ngIf="contratti && item.visible">
                  <mat-checkbox [(ngModel)]="item.value" [disabled]="item.disabled"
                    (change)="onSetDoc(item.key, item.schemaType, $event.checked, item.translation)" class="checkbox-insert">
                    <span *ngIf="lang === 'it'">{{ item.translation.it }}</span>
                    <span *ngIf="lang !== 'it'">{{ item.translation.en }}</span>
                  </mat-checkbox>
                </div>
                <div class="text-wrapper" *ngIf="!contratti && !unitaImmobiliari && item.visible">
                  <mat-checkbox [(ngModel)]="item.value" [disabled]="item.disabled"
                    (change)="onSetDoc(item.key, item.schemaType, $event.checked, item.translation)" class="checkbox-insert">
                    <span *ngIf="lang === 'it'">{{ item.translation.it }}</span>
                    <span *ngIf="lang !== 'it'">{{ item.translation.en }}</span>
                  </mat-checkbox>
                </div>
                <div class="text-wrapper" *ngIf="unitaImmobiliari && item.key && item.visible">
                  <mat-checkbox [(ngModel)]="item.value" [disabled]="item.disabled"
                    (change)="onSetDoc(item.key, item.schemaType, $event.checked, item.translation, item.parentTitle)" class="checkbox-insert">
                    <span *ngIf="lang === 'it'">{{ item.translation.it }}</span>
                    <span *ngIf="lang !== 'it'">{{ item.translation.en }}</span>
                  </mat-checkbox>
                </div>
                <div class="text-wrapper" *ngIf="unitaImmobiliari && !item.key">
                  <strong *ngIf="lang === 'it'">{{ item.it }}</strong>
                  <strong *ngIf="lang !== 'it'">{{ item.en }}</strong>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="col-5" [ngClass]="{'d-none': !displayedStructures.length}">
            <h5 *ngIf="title !== 'gestAmmTivoDipendenti'">
              {{ 'properties.addDocumentsPage.structresSelected' | translate }}</h5>
            <h5 *ngIf="title === 'gestAmmTivoDipendenti'">{{ 'properties.addDocumentsPage.employees' | translate }}</h5>
            <div *ngFor="let item of displayedStructures; let i = index;">
              <div class="text-wrapper">
                <mat-checkbox [(ngModel)]="item.value" (change)="onChangePlant(item, $event.checked)"
                  class="checkbox-insert">
                  {{ item.name }}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-7 col-lg-6">
        <h5>{{ 'properties.addDocumentsPage.fieldsData' | translate }}</h5>
        <div>
          <form [formGroup]="form">
            <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
          </form>
        </div> <!-- /.form-wrapper -->
      </div>
    </div>

  </mat-dialog-content> <!-- mat-dialog-content -->
  <div mat-dialog-actions>
    <div class="row w-100">
      <div class="col-6 text-left">
        <a mat-button (click)="onClose()" mat-raised-button mat-default
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div> <!-- /.col -->
      <div class="col-6 text-right">
        <mat-spinner-button (btnClick)="onFormSubmit()" role="submit" [options]="formBtnOptions" class="btn-elevate">
        </mat-spinner-button>
      </div> <!-- /.col -->
    </div> <!-- /.row -->
  </div>
</ng-container>

<ng-container class="digital-document-wrapper" *ngIf="docType && docUploaded">
  <div class="row p-5">
    <div class="col-12">
      <div class="row">
        <div class="col-12 text-center mb-4">
          {{ 'properties.addDocumentsPage.docTypes.successMessage' | translate }}
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <mat-spinner-button (btnClick)="onPrint('module')" [options]="printModuleBtnOptions" class="btn-elevate">
          </mat-spinner-button>
          <mat-spinner-button (btnClick)="onPrint('qr')" [options]="printQrBtnOptions" class="btn-elevate ml-2">
          </mat-spinner-button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="text-left w-100">
        <a mat-button (click)="onClose({ save: 'success' })" mat-raised-button mat-default
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div>
    </div>
  </div>
</ng-container>


<!-- <div class="row">
  <div class="col-8">
    Eelenco documenti da inserire:
    <div *ngFor="let item of data.documents" class="mt-2">
      - {{ item.title }}
    </div>
  </div>
  <div class="col-4">

  </div>
</div>

<div class="form-wrapper mt-5">
  <form [formGroup]="form">
    <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
    <div class="row mb-1">
      <div class="col-12" *ngFor="let item of existingNotes">
        <div class="note-preview-box">
          <div class="created-at" title="{{ item.createdAt }}">{{ item.createdAt | date }} - {{ item.createdBy }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </form>
</div> -->